import { BellStroke16 } from '@cian/ui-kit/icons';
import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Utility } from '../../components/Utility';
import { IApplicationState } from '../../types/redux';
import { NotificationCenterContainer } from '../NotificationCenterContainer';
import { trackNotificationIconClick } from './tracking';

export const UtilityNotificationsContainer: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const deviceType = useDeviceType();
  const notificationsLink = useSelector<IApplicationState, string | undefined>(
    state => state.servicesLinks.notifications || undefined,
  );
  const notificationsCount = useSelector<IApplicationState, number>(state => state.notifications.count);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (deviceType === 'desktop') {
        event.preventDefault();
        setIsOpen(true);
      }

      trackNotificationIconClick();
    },
    [deviceType],
  );

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  if (!notificationsLink && deviceType !== 'desktop') {
    return null;
  }

  return (
    <>
      <Utility
        title="Уведомления"
        unread={Boolean(notificationsCount)}
        icon={BellStroke16}
        href={notificationsLink}
        onClick={handleClick}
      />
      {isOpen && <NotificationCenterContainer onClose={handleClose} />}
    </>
  );
};
